import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OrderItem } from '../models/order-item';
import { CartService } from 'ng-shopping-cart';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Tenant } from '../models/tenant';
import { Order_Dto, Order_Item_Dto } from '../models/order-dto';
import { Location } from '@angular/common';

import { TenantService } from '../services/data.tenant';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.html'
})
export class ShoppingCartComponent implements OnInit {
  public tenant: Tenant;
  public h: HttpClient;
  public scust: Order_Dto = new Order_Dto();
  public id: any;
  mailForm: FormGroup;
  constructor(private router : Router, private location : Location, private tenantService: TenantService, private route: ActivatedRoute, http: HttpClient, @Inject('BASE_URL') baseUrl: string, private cartService: CartService<OrderItem>) {
    this.h = http;
  }

  ngOnInit() {
    this.tenantService.currentTenant.subscribe(tenant => this.tenant = tenant);
    this.scust = new Order_Dto();
    this.scust.tenantId = this.tenant.id;
    this.id = this.tenant.id;
    this.scust.validationMethod = 'both';

    this.mailForm = new FormGroup({
      lname: new FormControl(null, Validators.required),
      fname: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.required),
      phone: new FormControl(null, Validators.required),
      validationMethod : new FormControl()
    });
  }

  goBack(): void {
    this.location.back();
  }
  public reset() {
    this.cartService.clear();
    this.scust = new Order_Dto();
    this.scust.tenantId = this.tenant.id;

  }
  checkout(event) {
   
    this.scust
    this.scust.tenantId = this.tenant.id;
    this.scust.id = 0;
    this.scust.isMobile = true;
    this.scust.items = new Array();
    var items = this.scust.items;

    this.cartService.getItems().forEach(function (item) {
      var odi: Order_Item_Dto = new Order_Item_Dto();
      odi.orderId = 0;
      odi.productId = +item._id.split("-")[0];
      odi.quantity = item.Quantity;
      odi.size = item.size;
      items.push(odi);
    });

    this.h.post("api/Product/", this.scust).subscribe(result => {
      console.log(result);
    }, error => console.error(error));
    
    this.reset();
    
    this.router.navigateByUrl('/validate');
  }
}




// WEBPACK FOOTER //
// ./src/app/shopping-cart/shopping-cart.ts